import { Routes } from "./routes";

export const App = () => <Routes />;

export default App;
